import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DependenciesEdit from './DependenciesEdit';
import DependenciesList from './DependenciesList';
import AuthRoute, { AuthRouteConditions } from '@/components/app/AuthRoute';

interface DependenciesProps {}
const adminOnly: AuthRouteConditions = { project: 'isAdministrator' };

export const DependenciesRouting = (_: DependenciesProps) => {
    const match = useRouteMatch();
    const baseUrl = match.path;
    return (
        <Switch>
            <Route exact path={`${baseUrl}`}>
                <DependenciesList />
            </Route>
            <AuthRoute conditions={adminOnly} component={DependenciesEdit} path={`${baseUrl}/create`} />
            <Route
                path={`${baseUrl}/edit/:id`}
                render={(props) => <DependenciesEdit dependencyLinkId={+props.match.params.id} />}
            />
        </Switch>
    );
};
